import React from 'react';
import ReactDOM from 'react-dom';
import Register from './components/Register';

let root    = document.getElementById('newsletter-signup-root');
let lang    = root.getAttribute('data-lang') || 'no';
let media   = root.getAttribute('data-media') || 'default';

ReactDOM.render(
  <Register lang={lang} media={media}/>,
  root
);


// WEBPACK FOOTER //
// ./src/index.js